<template>
    <v-container fluid px-3 pt-3>
        <v-row row wrap>
            <v-col cols="12">
                <h3>Birth Verification</h3>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row row wrap>
            <v-col>
                <v-card>
                    <v-form v-model="formValid" ref="birthVerForm">
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <h4>Birth </h4>
                                    Legal Name at birth
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="3">
                                    <v-text-field label="First Name" v-model="birthVerificationDto.firstName" required :rules="requiredRule"></v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field :persistent-hint="true" hint="Optional" label="Middle Name" v-model="birthVerificationDto.middleName"></v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field label="Last Name" v-model="birthVerificationDto.lastName" required :rules="requiredRule"></v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field label="Birthdate" validate-on-blur type="date" v-model="birthVerificationDto.dateOfBirth" required :rules="requiredRule">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <h4>Parent 1 (Optional)</h4>
                                    Legal Name at the time of child's birth
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="3">
                                    <v-text-field label="First Name" v-model="birthVerificationDto.parent1FirstName"></v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field label="Middle Name" v-model="birthVerificationDto.parent1MiddleName"></v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field label="Last Name" v-model="birthVerificationDto.parent1LastName"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <h4>Parent 2 (Optional)</h4>
                                    Legal Name at the time of child's birth
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="3">
                                    <v-text-field label="First Name" v-model="birthVerificationDto.parent2FirstName"></v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field label="Middle Name" v-model="birthVerificationDto.parent2MiddleName"></v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field label="Last Name" v-model="birthVerificationDto.parent2LastName"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6">
                                    <!--<v-select label="Reason for Verification" v-model="birthVerificationDto.verificationReason"
                                        required :rules="requiredRule"
                                        :items="reasons">
                                    </v-select>-->
                                    <b>This verification is for government use only. Please enter in some information related to your request (Employee ID, Request ID, etc.)</b>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field label="Additional Information" v-model="verificationReasonExtraInfo" :rules="requiredRule" required></v-text-field>
                                </v-col>
                            </v-row>
                            <div v-if="errors.length > 0">
                                <v-row  v-for="error in errors" :key="error">
                                    <b style="color:red">{{error}}</b>
                                </v-row>
                            </div>
                            <v-row>
                                <v-col cols="12">
                                    <v-btn color="secondary" :disabled="isLoading || !formValid" @click="sendBirthVerification">
                                        SUBMIT
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>
        <div v-if="!!response && response.matchedRecords.length === 1">
            <v-row>
                <v-col>
                    <v-icon color="green">mdi-check-circle</v-icon>
                    <label>  Verified!</label>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-data-table :items="response.matchedRecords" :headers="headers" item-key="birthId">
                    </v-data-table>
                </v-col>
            </v-row>

            <v-row >
                <v-col cols="12">
                    You may Print the Verification for your records using the button below.
                </v-col>
                <v-col cols="12" v-show="abstractRequested">
                    An abstract has been requested, once approved you will see it in your inbox.
                </v-col>
                <v-col cols="12" v-show="patAffRequested">
                    A paternity affidavit has been requested, once approved you will see it in your inbox.
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="3" style="padding-left:25px;">
                    <v-btn @click="printVerification" :disabled="isPrinting">Print</v-btn>
                </v-col>
                <v-col cols="5" v-if="patAffAccess">
                    <v-btn @click="contactVssForPatAff" :disabled="patAffRequested">Request Paternity Affidavit</v-btn>
                </v-col>
                <v-spacer />
            </v-row>
        </div>
        <div v-else-if="!!response && response.matchedRecords.length > 1">
            <v-row>
                <v-col>
                    <v-icon color="yellow">mdi-help-circle</v-icon>
                    <label>  Potential Matches</label>
                </v-col>
            </v-row>
            <v-row >
                <v-col cols="6">
                    There is more than one match for this request. Please fill out one or both parent names to narrow it down or contact VSS.
                </v-col>
            </v-row>
        </div>
        <div v-else-if="!!response && response.matchedRecords.length === 0">
            <v-row>
                <v-col>
                    <v-icon color="red">mdi-close-circle</v-icon>
                    <label>  Not Verified</label>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6">
                    If you believe this to be an error you may contact VSS for a more refined search.
                </v-col>
            </v-row>
        </div>
        <contact-vss :operationType="operationType" :requestId="requestId" :modType="10" :numMatches="numberOfMatches"></contact-vss>
    </v-container>
</template>

<script>
import mailService from '@/services/mailService'
import verificationService from '@/services/verificationService'
import mediaService from '@/services/mediaService'
import userService from '@/services/userService'
import ContactVss from '../components/ContactVss.vue'

export default {
    components: {
        ContactVss
    },
    data: () => {
        return {
            isLoading: false,
            isPrinting: false,
            abstractRequested: false,
            patAffRequested: false,
            birthVerificationDto: {
                firstName: '',
                middleName: '',
                lastName: '',
                dateOfBirth: '',
                matched: null,
                parent1FirstName: '',
                parent1MiddleName: '',
                parent1LastName: '',
                parent2FirstName: '',
                parent2MiddleName: '',
                parent2LastName: '',
                verificationReason: ''
            },
            verificationReasonExtraInfo: '',
            headers: [
                { text: 'First Name', value: 'firstName' },
                { text: 'Middle Name', value: 'middleName' },
                { text: 'Last Name', value: 'lastName' },
                { text: 'Sex', value: 'sex' },
                { text: 'Date of Birth', value: 'dateOfBirth' },
                { text: 'Parent 1 First Name', value: 'parent1FirstName' },
                { text: 'Parent 1 Middle Name', value: 'parent1MiddleName' },
                { text: 'Parent 1 Last Name', value: 'parent1LastName' },
                { text: 'Parent 2 First Name', value: 'parent2FirstName' },
                { text: 'Parent 2 Middle Name', value: 'parent2MiddleName' },
                { text: 'Parent 2 Last Name', value: 'parent2LastName' }
            ],
            reasons: ['Reason 1'],
            menu: false,
            verificationSent: false,
            requiredRule: [v => !!v || 'Required', v => v.trim() !== '' || 'Invalid Input'],
            formValid: false,
            response: '',
            numberOfMatches: null,
            requestId: 0,
            errors: [],
            operationType: mailService.OperationEnum.Verification
        }
    },
    computed: {
        patAffAccess () {
            return this.verificationSent && userService.isPatAffReqUser()
        }
    },
    methods: {
        sendBirthVerification () {
            this.errors = []
            this.$refs.birthVerForm.validate()
            if (this.formValid) {
                this.isLoading = true
                this.birthVerificationDto.verificationReason += ' ' + this.verificationReasonExtraInfo
                verificationService.birthVerification(this.$http, this.birthVerificationDto).then(result => {
                    if (result.data && !result.data.errorMessages) {
                        this.response = result.data
                        this.numberOfMatches = this.response.matchedRecords.length
                        this.requestId = result.data.requestId
                    } else {
                        this.errors = result.data.errorMessages
                    }
                    this.verificationSent = true
                    this.isLoading = false
                })
            }
        },
        contactVSSForAbstract () {
            verificationService.verificationRequestAbstract(this.$http, this.requestId)
            this.abstractRequested = true
        },
        contactVssForPatAff () {
            verificationService.verificationRequestPatAff(this.$http, this.requestId)
            this.patAffRequested = true
        },
        printVerification () {
            this.isPrinting = true
            verificationService.verificationPrint(this.$http, this.requestId).then(response => {
                mediaService.fileToDownload(response, 'birthVerification_request' + this.requestId + '.pdf')
                this.isPrinting = false
            })
        }
    }
}
</script>
